import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterVendor'
})
export class FilterVendorPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
    
      return it.vendor_name.toLowerCase().includes(searchText.toLowerCase());
     
    });
  }

}
